// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"80":"f2dd2733","547":"e68cd234","561":"126233a7","921":"6eef210b"}[chunkId] + ".js";
};